module.exports = __webpack_public_path__ + "media/images/homes/service-173610bf27cf3af59be347439b6c1033.png";